import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ButtonType, IconName, ModalComponent } from '@yupma/ui-kit';
import { ActivityField, DefaultEntityFields, EntityAddFormField, EntityType, FieldDocument, FieldGroupDocument, Sorting, SortOrder } from 'server-model';

@Component({
  selector: 'app-entity-sort-modal',
  templateUrl: './entity-sort-modal.component.html',
  styleUrl: './entity-sort-modal.component.scss'
})
export class EntitySortModalComponent implements OnInit {
  @ViewChild(ModalComponent) modalComponent!: ModalComponent;
  @Input() entityType: EntityType = EntityType.CONTACT;
  @Input() sorting: Sorting[] = [new Sorting(DefaultEntityFields.UPDATED_ON, SortOrder.DESC)];
  @Input() fieldDocuments: FieldDocument[] | ActivityField[] = [];
  @Input() fieldGroups: FieldGroupDocument[] = [];
  @Output() onSortingApply = new EventEmitter<Sorting[]>();
  @Output() onClose = new EventEmitter();
  showModal: boolean = true;

  buttonTypes = ButtonType;
  isLoading: boolean = false;
  iconNames = IconName;
  sortOrders = SortOrder;
  activeSortOrder: SortOrder = SortOrder.DESC
  selectedField: FieldDocument | ActivityField | null = null;

  ngOnInit() {
    const fieldName = this.sorting[0].field;
    const newField = this.fieldDocuments.find(field => field.name === fieldName || field.name === DefaultEntityFields.UPDATED_ON || field.name === 'due_date');
    if (!newField || newField === this.selectedField) {
      return;
    }
    this.selectedField = newField;
    console.log("this selectedfield", this.selectedField, fieldName)
  }

  toggleModal() {
    this.showModal = !this.showModal
    if (!this.showModal) {
      this.onClose.emit();
    }
  }

  updateSorting(sorting: Sorting) {
    this.sorting = [sorting, new Sorting(DefaultEntityFields.ID, SortOrder.DESC)];
  }

  resetSorting() {
    this.sorting = [new Sorting(DefaultEntityFields.UPDATED_ON, SortOrder.DESC)];
    this.onSortingApply.emit(this.sorting);
  }

  saveFilter() {
    if (this.sorting) {
      this.onSortingApply.emit(this.sorting);
    }
    this.modalComponent.closeModal();
  }


  toggleActiveSorting(order: SortOrder) {
    this.activeSortOrder = order

    if (this.selectedField) {
      const sorting = new Sorting(this.selectedField.name, this.activeSortOrder);
      this.updateSorting(sorting)
    }
  }

  updateSelectedField(selections: EntityAddFormField[]) {
    const fieldName = selections[0].field_name;
    const newField = this.fieldDocuments.find(field => field.name === fieldName);
    if (!newField || newField === this.selectedField) {
      return;
    }
    this.selectedField = newField;
    const sorting = new Sorting(fieldName, this.activeSortOrder);
    this.updateSorting(sorting)
  }
}
